import { FaPlus, FaMinus } from "react-icons/fa";
import "./CartPage.css";
import { useCart } from "../Context/CartContext";
import { useAuth } from "../Context/AuthContext";
import { Navigate } from "react-router-dom";

export default function CartPage() {
  const { cart, removeFromCart, increaseQty, decreaseQty } = useCart();
  const { user } = useAuth();

  // If user not logged in redirect to login
  if (!user) {
    return <Navigate to="/signinandsignup" />;
  }

  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0);
  const totalItems = cart.reduce((sum, item) => sum + item.qty, 0);

  return (
    <section className="cart-page">
      {/* TOP TOTAL */}
      <aside className="cart-alltotal">
        <p className="cart-total">
          Total <span className="cart-total-price">₹{total}</span>
          <span>
            <a href="#cart-total-display"> View details</a>
          </span>
        </p>

        <button className="cart-buy-button">
          Proceed to Buy ({totalItems} items)
        </button>
      </aside>

      <hr />

      <div className="cart-display-product-total">
        {/* CART PRODUCTS */}
        <aside className="cart-product-display-all">
          {cart.length === 0 ? (
            <div className="empty-products">
              <h3>No products available</h3>
              <p>Please check back later 🌸</p>
            </div>
          ) : (
            cart.map((item) => {
              const image = item.images?.[0] || item.image?.[0] || item.image;

              return (
                <div className="cart-product-display" key={item.id}>
                  <div className="cart-product-data">
                    {/* PRODUCT IMAGE */}
                    <div className="cart-product-image">
                      <img src={image} alt={item.name} />
                    </div>

                    {/* PRODUCT INFO */}
                    <div className="cart-product-info">
                      <p className="cart-product-name">{item.name}</p>

                      <div className="cart-price">₹{item.price}</div>

                      <div className="cart-date">Delivery available</div>

                      <div className="cart-stock">In Stock</div>

                      {/* DESKTOP QUANTITY */}
                      <div className="cart-quantity-desktop">
                        <div className="cart-product-quantity">
                          <div
                            className="cart-minus"
                            onClick={() => decreaseQty(item.id)}
                          >
                            <FaMinus />
                          </div>

                          <div className="cart-quantity">{item.qty}</div>

                          <div
                            className="cart-plus"
                            onClick={() => increaseQty(item.id)}
                          >
                            <FaPlus />
                          </div>
                        </div>

                        <button onClick={() => removeFromCart(item.id)}>
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* MOBILE QUANTITY */}
                  <div className="cart-quantity-mobile">
                    <div className="cart-product-quantity">
                      <div
                        className="cart-minus"
                        onClick={() => decreaseQty(item.id)}
                      >
                        <FaMinus />
                      </div>

                      <div className="cart-quantity">{item.qty}</div>

                      <div
                        className="cart-plus"
                        onClick={() => increaseQty(item.id)}
                      >
                        <FaPlus />
                      </div>
                    </div>

                    <button onClick={() => removeFromCart(item.id)}>
                      Delete
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </aside>

        {/* CART TOTAL DETAILS */}
        <aside className="cart-total-display" id="cart-total-display">
          <div className="cart-delivery-item">
            <div className="cart-delivery-name">
              <p className="cart-items">Items:</p>
              <p className="cart-delivery">Delivery:</p>
            </div>

            <div className="cart-delivery-price">
              <p className="cart-item-price">₹{total}</p>
              <p className="cart-delivery-price">₹0.00</p>
            </div>
          </div>

          <div className="cart-delivery-total">
            <p className="cart-order-total">Order Total:</p>
            <p className="cart-order-price">₹{total}</p>
          </div>
        </aside>
      </div>
    </section>
  );
}
